import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {columnHalf, containerStackMobile} from '@fo/shared/styles/mixins/layout';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  lookingForFinance: css`
    label: LookingForFinance;
    margin-top: ${spacing.XS};
  `,
  wrapper: (small = false): string => css`
    label: LookingForFinance__wrapper;
    ${containerStackMobile};

    background: ${colours.background.SECTION};

    ${small
      ? css`
          padding: ${spacing.XS};
        `
      : css`
          padding: ${spacing.M} ${spacing.XXS};

          ${mq(Breakpoints.TABLET)} {
            padding: ${spacing.L} ${spacing.S};
          }

          ${mq(Breakpoints.DESKTOP)} {
            padding: ${spacing.L} 7rem;
          }
        `}
  `,
  titleWrapper: (small = false): string => css`
    label: LookingForFinance__titleWrapper;
    ${!small &&
    css`
      margin-bottom: ${spacing.XXS};
    `};

    ${mq(Breakpoints.TABLET)} {
      margin-bottom: 0;
      padding-right: ${spacing.S};
    }
  `,
  showCheckpoints: css`
    label: LookingForFinance__showCheckpoints;
    ${mq(Breakpoints.TABLET)} {
      ${columnHalf};
    }
  `,
  title: css`
    label: LookingForFinance__title;
    margin-top: 0;
    margin-bottom: ${spacing.XS};
  `,
  subtitle: (small = false): string => css`
    label: LookingForFinance__subtitle;
    margin-bottom: ${small ? spacing.XS : spacing.S};
    color: ${colours.font.BLACK};
  `,
  content: css`
    label: LookingForFinance__content;
    ${mq(Breakpoints.TABLET)} {
      ${columnHalf};
      padding-left: ${spacing.S};
    }
  `,
};

export default styles;
